import React from 'react';

/**
 * Logo oficial PreventiApp — recreado en SVG fiel al brand:
 * - Escudo en azul violeta (#5346E6)
 * - Ondas concéntricas en azul tecnológico/celeste
 * - Wordmark "Preventi" en azul profundo + "App" en celeste
 * Acepta props: variant ("full" | "mark"), inverted (boolean) y className.
 */
export const PreventiAppLogo = ({ variant = 'full', inverted = false, className = '', showTagline = false }) => {
  const shieldStroke = inverted ? '#FFFFFF' : '#5346E6';
  const wavePrimary = inverted ? '#78A8FF' : '#2F6BFF';
  const waveSecondary = inverted ? '#C8D8FF' : '#78A8FF';
  const dot = inverted ? '#78A8FF' : '#5346E6';
  const wordDeep = inverted ? '#FFFFFF' : '#0B1B5E';
  const wordSky = inverted ? '#78A8FF' : '#5346E6';
  const tagline = inverted ? '#C8D8FF' : '#0B1B5E';

  if (variant === 'mark') {
    return (
      <svg viewBox="0 0 64 72" className={className} aria-label="PreventiApp">
        <path
          d="M32 4 L58 14 V36 C58 52 46 64 32 68 C18 64 6 52 6 36 V14 Z"
          fill="none"
          stroke={shieldStroke}
          strokeWidth="4"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <circle cx="24" cy="36" r="2.6" fill={dot} />
        <path d="M28 30 Q32 36 28 42" fill="none" stroke={wavePrimary} strokeWidth="2.4" strokeLinecap="round" />
        <path d="M33 26 Q39 36 33 46" fill="none" stroke={waveSecondary} strokeWidth="2.4" strokeLinecap="round" />
        <path d="M38 22 Q46 36 38 50" fill="none" stroke={waveSecondary} strokeWidth="2.2" strokeLinecap="round" opacity="0.7" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 360 96" className={className} aria-label="PreventiApp — Centro de Inteligencia Preventiva Escolar">
      {/* shield */}
      <g transform="translate(0,8)">
        <path
          d="M32 4 L58 14 V36 C58 52 46 64 32 68 C18 64 6 52 6 36 V14 Z"
          fill="none"
          stroke={shieldStroke}
          strokeWidth="4"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <circle cx="24" cy="36" r="2.6" fill={dot} />
        <path d="M28 30 Q32 36 28 42" fill="none" stroke={wavePrimary} strokeWidth="2.4" strokeLinecap="round" />
        <path d="M33 26 Q39 36 33 46" fill="none" stroke={waveSecondary} strokeWidth="2.4" strokeLinecap="round" />
        <path d="M38 22 Q46 36 38 50" fill="none" stroke={waveSecondary} strokeWidth="2.2" strokeLinecap="round" opacity="0.7" />
      </g>
      {/* wordmark */}
      <text
        x="78"
        y="50"
        fontFamily="Plus Jakarta Sans, Manrope, sans-serif"
        fontWeight="800"
        fontSize="34"
        letterSpacing="-0.02em"
      >
        <tspan fill={wordDeep}>Preventi</tspan>
        <tspan fill={wordSky}>App</tspan>
      </text>
      {showTagline && (
        <text
          x="80"
          y="74"
          fontFamily="Manrope, sans-serif"
          fontWeight="500"
          fontSize="12"
          fill={tagline}
          letterSpacing="0.01em"
        >
          Centro de Inteligencia Preventiva Escolar
        </text>
      )}
    </svg>
  );
};

export default PreventiAppLogo;
